"use client";

import { usePathname } from "next/navigation";
import { Header } from "@/components/layout/Header";
import { Sidebar } from "@/components/layout/Sidebar";
import { Fast360SesionBanner } from "@/components/layout/Fast360SesionBanner";
import { BrandProvider, useBrand } from "@/context/BrandContext";

function AppLayoutInner({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const { isSegurclassic } = useBrand();
  const isPublicPage =
    pathname === "/login" ||
    pathname === "/blocked" ||
    pathname.startsWith("/upload-docs") ||
    pathname.endsWith("/modo-emision");

  if (isPublicPage) {
    return <>{children}</>;
  }

  return (
    <div className="flex h-screen overflow-hidden bg-background bg-dot-pattern">
      <a href="#main-content" className="skip-link">
        Saltar al contenido principal
      </a>
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden min-w-0">
        <Header />
        <Fast360SesionBanner />
        <main
          id="main-content"
          aria-label="Contenido principal"
          className={`flex-1 overflow-y-auto p-4 md:p-6 lg:p-8 transition-colors duration-300 ${isSegurclassic ? "content-segurclassic" : ""}`}
        >
          <div className="w-full h-full flex flex-col">{children}</div>
        </main>
      </div>
    </div>
  );
}

export function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <BrandProvider>
      <AppLayoutInner>{children}</AppLayoutInner>
    </BrandProvider>
  );
}
